import { render, staticRenderFns } from "./IpoAllocatedSummaryRow.vue?vue&type=template&id=ea165fbc&scoped=true"
import script from "./IpoAllocatedSummaryRow.vue?vue&type=script&lang=js"
export * from "./IpoAllocatedSummaryRow.vue?vue&type=script&lang=js"
import style0 from "./IpoAllocatedSummaryRow.vue?vue&type=style&index=0&id=ea165fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea165fbc",
  null
  
)

export default component.exports